const Data = [
  {
    id: 1,
    category: "first-col",
    icon: "icon-graduation",
    time: "",
    title: "BSc in Computer Science",
    desc: "Georgia State University",
  },
  {
    id: 2,
    category: "first-col",
    icon: "icon-graduation",
    time: "",
    title: "Higher National Diploma of Informatics",
    desc: "Hanoi-Amsterdam High School for the Gifted",
  },
  {
    id: 3,
    category: "second-col",
    icon: "icon-graduation",
    time: "",
    title: "Honors & Awards",
    desc: "President’s List & STEM Honors Student Scholar (all semesters), Honors College",
  },
  {
    id: 4,
    category: "second-col",
    icon: "icon-graduation",
    time: "",
    title: "CodePath Scholar",
    desc: "Advanced Technical Interview Prep, Emerging Engineers Summit 2025",
  },
  
];

export default Data
